import { createFileRoute, useParams } from "@tanstack/react-router";
import { CaseDetailPage } from "@/components/crm/CaseDetailPage";

export const Route = createFileRoute("/admin/_layout/crm/cases_/$id")({
  component: AdminCaseDetail,
});

function AdminCaseDetail() {
  const { id } = useParams({ from: "/admin/_layout/crm/cases_/$id" });
  return <CaseDetailPage caseId={id} role="admin" />;
}
